(function () {
  if (window.__dtGokwikCheckoutRuntimeLoaded) return;
  window.__dtGokwikCheckoutRuntimeLoaded = true;

  var CHECKOUT_SELECTOR = '[data-dt-gokwik-checkout], .gokwik-checkout .cart-drawer__checkout-btn';
  var CHECKOUT_WAIT_MS = 12000;
  var CHECKOUT_POLL_MS = 100;
  var CART_CACHE_MS = 1500;
  var STATE_TEXT = {
    syncing: 'Updating cart…',
    opening: 'Opening secure checkout…',
    opened: 'Checkout opened',
    retry: 'Try checkout again'
  };
  var STATE_STATUS = {
    syncing: 'Updating your cart before checkout.',
    opening: 'Opening secure checkout.',
    opened: 'Secure checkout opened.'
  };
  var checkoutState = 'booting';
  var activeAttempt = 0;
  var lastCheckoutButton = null;
  var cachedCart = null;
  var cachedCartAt = 0;
  var cartReadPromise = null;

  function getCheckoutButtons(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var buttons = [];

    if (scope.matches && scope.matches(CHECKOUT_SELECTOR)) buttons.push(scope);
    Array.prototype.push.apply(buttons, scope.querySelectorAll(CHECKOUT_SELECTOR));
    return buttons;
  }

  function getStatus(button) {
    var container = button && button.closest ? button.closest('.gokwik-checkout') : null;
    return container ? container.querySelector('[data-dt-gokwik-checkout-status]') : null;
  }

  function setStatus(button, message) {
    var status = getStatus(button);
    if (status) status.textContent = message || '';
  }

  function setButtonState(button, state, statusMessage) {
    if (!button) return;

    var label = button.querySelector('.btn-text');
    var isBusy = state === 'syncing' || state === 'opening';
    var isDisabled = state === 'booting' || isBusy || state === 'opened';

    if (label) {
      label.dataset.readyText = label.dataset.readyText || label.textContent.trim() || 'Proceed to Checkout';
      label.textContent = STATE_TEXT[state] || label.dataset.readyText;
    }

    button.setAttribute('data-dt-gokwik-checkout', '');
    button.dataset.checkoutState = state;
    button.dataset.checkoutPending = isBusy ? 'true' : 'false';
    button.setAttribute('aria-busy', isBusy ? 'true' : 'false');
    button.classList.toggle('dt-gokwik-waiting', isBusy);
    button.classList.toggle('disabled', isBusy || state === 'opened');
    button.disabled = isDisabled;
    button.removeAttribute('onclick');
    setStatus(button, statusMessage === undefined ? STATE_STATUS[state] : statusMessage);
  }

  function setCheckoutState(state, statusMessage) {
    checkoutState = state;
    getCheckoutButtons(document).forEach(function (button) {
      setButtonState(button, state, statusMessage);
    });
  }

  function initializeCheckoutButtons(root) {
    getCheckoutButtons(root).forEach(function (button) {
      setButtonState(button, checkoutState);
    });
  }

  function setRetryState(message) {
    setCheckoutState('retry', message || 'Checkout could not open. Please try again.');
  }

  function getVisibleGokwikFrame() {
    var frames = document.querySelectorAll('#gokwik-iframe, iframe[src*="pdp.gokwik.co/index"], iframe[src*="gokwik.co/index"]');

    return Array.prototype.find.call(frames, function (frame) {
      var rect = frame.getBoundingClientRect();
      var style = window.getComputedStyle(frame);
      return style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 0 && rect.height > 0;
    }) || null;
  }

  function waitForVisibleGokwikFrame(attemptId) {
    return new Promise(function (resolve) {
      var startedAt = Date.now();

      function check() {
        if (attemptId !== activeAttempt) {
          resolve(null);
          return;
        }

        var frame = getVisibleGokwikFrame();
        if (frame) {
          resolve(frame);
          return;
        }

        if (Date.now() - startedAt >= CHECKOUT_WAIT_MS) {
          resolve(null);
          return;
        }

        window.setTimeout(check, CHECKOUT_POLL_MS);
      }

      check();
    });
  }

  function getCheckoutFeedback() {
    if (window.dtGokwikCheckoutFeedback && typeof window.dtGokwikCheckoutFeedback.begin === 'function') {
      return window.dtGokwikCheckoutFeedback;
    }

    var overlay = null;
    var hideTimer = null;
    var visibleStartedAt = 0;
    var minVisibleMs = 350;

    function ensureOverlay() {
      if (overlay && overlay.isConnected) return overlay;

      overlay = document.createElement('div');
      overlay.className = 'dt-gokwik-glass-overlay';
      overlay.setAttribute('aria-hidden', 'true');

      var panel = document.createElement('div');
      panel.className = 'dt-gokwik-glass-overlay__panel';

      var spinner = document.createElement('span');
      spinner.className = 'dt-gokwik-glass-overlay__spinner';
      spinner.setAttribute('aria-hidden', 'true');

      var message = document.createElement('span');
      message.className = 'dt-gokwik-glass-overlay__text';

      panel.appendChild(spinner);
      panel.appendChild(message);
      overlay.appendChild(panel);
      document.body.appendChild(overlay);
      return overlay;
    }

    function update(message) {
      var activeOverlay = ensureOverlay();
      var messageElement = activeOverlay.querySelector('.dt-gokwik-glass-overlay__text');
      if (messageElement) messageElement.textContent = message || 'Opening secure checkout…';
    }

    function begin(message) {
      if (getVisibleGokwikFrame()) return;
      if (hideTimer) window.clearTimeout(hideTimer);
      hideTimer = null;
      visibleStartedAt = Date.now();
      update(message);
      ensureOverlay().classList.add('is-visible');
    }

    function hide() {
      if (!overlay || !overlay.isConnected) return;
      if (hideTimer) window.clearTimeout(hideTimer);
      hideTimer = window.setTimeout(function () {
        hideTimer = null;
        if (!overlay || !overlay.isConnected) return;
        overlay.classList.remove('is-visible');
        window.setTimeout(function () {
          if (overlay && overlay.isConnected && !overlay.classList.contains('is-visible')) overlay.remove();
        }, 180);
      }, Math.max(0, minVisibleMs - (Date.now() - visibleStartedAt)));
    }

    window.dtGokwikCheckoutFeedback = { begin: begin, update: update, hide: hide };
    return window.dtGokwikCheckoutFeedback;
  }

  function wakeGoKwik() {
    if (typeof window.dtLoadGoKwik === 'function') window.dtLoadGoKwik();

    try {
      document.dispatchEvent(new CustomEvent('initGKJS'));
    } catch (eventError) {
      var initEvent = document.createEvent('Event');
      initEvent.initEvent('initGKJS', true, true);
      document.dispatchEvent(initEvent);
    }

    try {
      if (window.gokwikSdk && typeof window.gokwikSdk.init === 'function') window.gokwikSdk.init();
    } catch (initError) {
      console.warn('[GoKwik] Retry initialization failed.', initError);
    }
  }

  function getCheckoutStarter() {
    if (typeof window.triggerGokwikCustomCheckout === 'function') {
      return function () {
        window.triggerGokwikCustomCheckout();
      };
    }

    if (window.gokwikSdk && typeof window.gokwikSdk.initCheckout === 'function') {
      return function () {
        window.gokwikSdk.initCheckout(window.merchantInfo || {});
      };
    }

    if (typeof window.onCheckoutClick === 'function') {
      return function () {
        var proxyButton = document.createElement('button');
        proxyButton.appendChild(document.createElement('span'));
        window.onCheckoutClick(proxyButton);
      };
    }

    return null;
  }

  function waitForCheckoutStarter(attemptId) {
    return new Promise(function (resolve) {
      var startedAt = Date.now();

      function cleanup() {
        window.removeEventListener('gokwikLoaded', check);
      }

      function check() {
        if (attemptId !== activeAttempt) {
          cleanup();
          resolve(null);
          return;
        }

        var starter = getCheckoutStarter();
        if (starter) {
          cleanup();
          resolve(starter);
          return;
        }

        if (Date.now() - startedAt >= CHECKOUT_WAIT_MS) {
          cleanup();
          resolve(null);
          return;
        }

        window.setTimeout(check, CHECKOUT_POLL_MS);
      }

      window.addEventListener('gokwikLoaded', check);
      check();
    });
  }

  async function readCart() {
    if (cachedCart && Date.now() - cachedCartAt < CART_CACHE_MS) return cachedCart;
    if (cartReadPromise) return cartReadPromise;

    cartReadPromise = (async function () {
      try {
        var response = await fetch('/cart.js', { credentials: 'same-origin' });
        cachedCart = response.ok ? await response.json() : null;
        cachedCartAt = cachedCart ? Date.now() : 0;
        return cachedCart;
      } catch (error) {
        console.warn('[GoKwik] Unable to read cart before checkout', error);
        return null;
      } finally {
        cartReadPromise = null;
      }
    })();

    return cartReadPromise;
  }

  function invalidateCartCache() {
    cachedCart = null;
    cachedCartAt = 0;
  }

  function hasPendingCartMutations() {
    return Boolean(
      window.CartController &&
      typeof window.CartController.flushPendingCartMutations === 'function' &&
      (
        (window.CartController.pendingRemovalKeys && window.CartController.pendingRemovalKeys.size) ||
        (window.CartController.pendingQuantityUpdates && window.CartController.pendingQuantityUpdates.size) ||
        window.CartController.pendingQuantityPromise ||
        (window.CartController.pendingAddQueue && window.CartController.pendingAddQueue.length) ||
        window.CartController.pendingAddPromise
      )
    );
  }

  async function prepareStandardCheckoutCart(cart) {
    if (typeof window.dtReconcileFreebieCart === 'function') {
      cart = await window.dtReconcileFreebieCart(cart);
    }

    if (typeof window.dtClearByobOnlyDiscountArtifacts === 'function') {
      window.dtClearByobOnlyDiscountArtifacts({ cart: cart });
    }

    if (
      typeof window.dtCartHasByobOnlyDiscount === 'function' &&
      typeof window.dtClearByobOnlyShopifyDiscount === 'function' &&
      window.dtCartHasByobOnlyDiscount(cart)
    ) {
      await window.dtClearByobOnlyShopifyDiscount(cart, { allowByob: false, force: true });
      invalidateCartCache();
      cart = await readCart() || cart;
    }

    if (cart && typeof window.dtSyncGokwikTierDiscount === 'function') {
      window.dtSyncGokwikTierDiscount(cart);
    }
    if (typeof window.dtPrepareGokwikEasyBundleCart === 'function') {
      await window.dtPrepareGokwikEasyBundleCart(cart);
    }
  }

  function warmCheckout(event) {
    var cart = event && event.detail;

    initializeCheckoutButtons(document);
    if (!cart || !Array.isArray(cart.items)) cart = window.CartController && window.CartController.cart;
    if (!cart || !Array.isArray(cart.items)) cart = window.gokwikCart;

    if (cart && Array.isArray(cart.items)) {
      cachedCart = cart;
      cachedCartAt = Date.now();
    } else {
      readCart();
    }

    wakeGoKwik();
  }

  function focusCheckoutFrame(frame) {
    if (!frame || typeof frame.focus !== 'function') return;
    if (!frame.getAttribute('title')) frame.setAttribute('title', 'Secure checkout');
    try {
      frame.focus({ preventScroll: true });
    } catch (error) {
      frame.focus();
    }
  }

  function bindModalClose() {
    if (window.__dtGokwikModalCloseBound) return;
    if (!window.gokwikSdk || typeof window.gokwikSdk.on !== 'function') return;

    window.__dtGokwikModalCloseBound = true;
    window.gokwikSdk.on('modal_closed', function () {
      activeAttempt += 1;
      getCheckoutFeedback().hide();
      setCheckoutState('ready', '');
      if (lastCheckoutButton && lastCheckoutButton.isConnected && lastCheckoutButton.offsetParent !== null) {
        lastCheckoutButton.focus();
      }
    });
  }

  window.dtGokwikCheckoutClick = async function (button) {
    if (!button || checkoutState === 'syncing' || checkoutState === 'opening' || checkoutState === 'opened') return;

    var attemptId = ++activeAttempt;
    var checkoutFeedback = getCheckoutFeedback();
    var pendingCartMutations = hasPendingCartMutations();
    lastCheckoutButton = button;

    setCheckoutState(pendingCartMutations ? 'syncing' : 'opening');
    checkoutFeedback.begin(pendingCartMutations ? 'Updating your cart…' : 'Opening secure checkout…');

    try {
      if (pendingCartMutations) {
        var synced = await window.CartController.flushPendingCartMutations();
        if (attemptId !== activeAttempt) return;
        if (!synced) {
          setRetryState('Your cart is still updating. Please try again.');
          checkoutFeedback.hide();
          return;
        }
        invalidateCartCache();
        setCheckoutState('opening');
        checkoutFeedback.update('Opening secure checkout…');
      }

      var cart = await readCart();
      if (attemptId !== activeAttempt) return;
      await prepareStandardCheckoutCart(cart || window.gokwikCart);
      if (attemptId !== activeAttempt) return;

      wakeGoKwik();
      var startCheckout = await waitForCheckoutStarter(attemptId);
      if (attemptId !== activeAttempt) return;
      if (!startCheckout) {
        setRetryState('Checkout is not ready yet. Please try again.');
        checkoutFeedback.hide();
        return;
      }

      bindModalClose();
      startCheckout();

      var frame = await waitForVisibleGokwikFrame(attemptId);
      if (attemptId !== activeAttempt) return;
      if (!frame) {
        setRetryState('Checkout took too long to open. Please try again.');
        checkoutFeedback.hide();
        return;
      }

      setCheckoutState('opened');
      checkoutFeedback.hide();
      focusCheckoutFrame(frame);
    } catch (error) {
      if (attemptId !== activeAttempt) return;
      setRetryState();
      checkoutFeedback.hide();
      console.warn('[GoKwik] Checkout failed before opening.', error);
    }
  };

  document.addEventListener('click', function (event) {
    var button = event.target && event.target.closest ? event.target.closest(CHECKOUT_SELECTOR) : null;
    if (!button) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    window.dtGokwikCheckoutClick(button).catch(function (error) {
      setRetryState();
      getCheckoutFeedback().hide();
      console.warn('[GoKwik] Checkout click failed.', error);
    });
  }, true);

  document.addEventListener('cart:updated', function (event) {
    invalidateCartCache();
    warmCheckout(event);
  }, { passive: true });
  document.addEventListener('dt:cart-intent', warmCheckout, { passive: true });
  document.addEventListener('cart-drawer:opening', warmCheckout, { passive: true });
  document.addEventListener('cart-drawer:opened', warmCheckout, { passive: true });
  document.addEventListener('shopify:section:load', function () {
    initializeCheckoutButtons(document);
  });
  window.addEventListener('gokwikLoaded', bindModalClose);

  checkoutState = 'ready';
  initializeCheckoutButtons(document);
  bindModalClose();
})();
